import React, { useEffect } from 'react';
import { PrimaryButton } from 'utils';
import {
  PaymentElement,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';
import styled from '@emotion/styled';
import PaymentConsentText from './PaymentConsentText';

const StripeForm = ({
  selectedRewards,
  paymentType,
  project_id,
  amount,
  tips,
  setMessage,
  setIsProcessing,
  values,
  isTicketable,
  selectedKey,
  project,
  setElements,
  setStripe,
  options,
  onSubmitHandle,
  showSummary
}) => {
  const stripe = useStripe();
  const elements = useElements();

  useEffect(() => {
    setStripe(stripe);
    setElements(elements);
  }, [elements, setElements, setStripe, stripe]);

  return (
    <div>
      <div>
        {paymentType === 'card' && (
          <>
            <div className="payment_blk_in">
              <PaymentElement
                id="payment-element"
                options={{
                  ...options,
                  layout: { type: 'accordion', defaultCollapsed: true },
                }}
              />
            </div>
            {showSummary && (
              <MobileSummarySpace>{showSummary}</MobileSummarySpace>
            )}

            <PrimaryButton
              type="submit"
              minWidth={'100%'}
              className="payPalBtn"
              onClick={onSubmitHandle}
              style={{ marginBottom: '1px', marginTop: '25px' }}
            >
              {isTicketable ? 'Jetzt buchen' : 'Jetzt unterstützen'}
              {/*Jetzt zahlungspflichtig{' '}*/}
              {/*{isTicketable ? 'buchen' : 'unterstützen'}*/}
            </PrimaryButton>
            <PaymentConsentText />
          </>
        )}
      </div>
    </div>
  );
};

const MobileSummarySpace = styled.div`
  display: none;

  @media (max-width: 1100px) {
    display: block;
    margin-top: 32px;
  }
`;

export default StripeForm;
